export const normalizeSchoolDetails = (school) => ({
  ...school,
  school_type: school.school_type || "Public",
  board: school.board || "",
  branch_name: school.branch_name || "",
  address: school.address || "",
  city: school.city || "",
  state: school.state || "",
  country: school.country || "India",
  pincode: school.pincode || "",
  isd_code: school.isd_code || "+91",
  phone: school.phone || "",
  email: school.email || "",
  activation_code: school.activation_code || "",
  fee: school.fee || "",
  tier: school.tier || "",
  category: school.category || "",
  primary_contact_info: {
    ...school.primary_contact_info,
    name: school.primary_contact_info?.name || "",
    isd_code: school.primary_contact_info?.isd_code || "+91",
    phone: school.primary_contact_info?.phone || "",
    email: school.primary_contact_info?.email || "",
  },
  secondary_contact_info: {
    ...school.secondary_contact_info,
    name: school.secondary_contact_info?.name || "",
    isd_code: school.secondary_contact_info?.isd_code || "+91",
    phone: school.secondary_contact_info?.phone || "",
    email: school.secondary_contact_info?.email || "",
    designation: school.secondary_contact_info?.designation || "",
  },
  total_student_count: school.total_student_count || 0,
  total_teacher_count: school.total_teacher_count || 0,
  other_staff_count: school.other_staff_count || 0,
  grade_wise_count: {
    ...school.grade_wise_count,
    nursery: school.grade_wise_count?.nursery || 0,
    lkg: school.grade_wise_count?.lkg || 0,
    ukg: school.grade_wise_count?.ukg || 0,
    grade_1: school.grade_wise_count?.grade_1 || 0,
    grade_2: school.grade_wise_count?.grade_2 || 0,
    grade_3: school.grade_wise_count?.grade_3 || 0,
    grade_4: school.grade_wise_count?.grade_4 || 0,
    grade_5: school.grade_wise_count?.grade_5 || 0,
    grade_6: school.grade_wise_count?.grade_6 || 0,
    grade_7: school.grade_wise_count?.grade_7 || 0,
    grade_8: school.grade_wise_count?.grade_8 || 0,
    grade_9: school.grade_wise_count?.grade_9 || 0,
    grade_10: school.grade_wise_count?.grade_10 || 0,
    grade_11: school.grade_wise_count?.grade_11 || 0,
    grade_12: school.grade_wise_count?.grade_12 || 0,
  },
});
